import React, { useId } from 'react';

import { token } from '@atlaskit/tokens';

export const CardCoverArtwork = ({
	appearance = 'default',
}: {
	/** Use inverse artwork on a bold background without changing the grid pattern. */
	appearance?: 'default' | 'inverse';
}): React.JSX.Element => {
	const id = useId();
	const gridId = `${id}-grid`;

	return (
		<svg width="100%" height="100%" aria-hidden="true" focusable="false">
			<defs>
				<pattern id={gridId} width="20" height="20" patternUnits="userSpaceOnUse" x="50%" y="9">
					<path
						d="M 0 1 H 20 M 0 1 V 21"
						fill="none"
						stroke={
							appearance === 'inverse' ? token('color.border.inverse') : token('color.border.bold')
						}
						strokeOpacity={0.5}
						strokeWidth={1.25}
						strokeDasharray="0 4"
						strokeLinecap="round"
					/>
				</pattern>
			</defs>
			<rect width="100%" height="100%" fill={`url(#${gridId})`} />
		</svg>
	);
};
